<style scoped>
  .page {
    padding-top: 8px;
    margin-top: -48px;
    background: #EBF1FF;
  }
  .logo {
    display: block;
    width: 39.15vw;
    height: 8.47vw;
    margin-left: 4.94vw ;
    margin-bottom: 6.35vw;
  }

  .feathers {
    width: 80.6vw;
    margin: 0 auto;
    
  }
  .feathers img{
    width: block;
    width: 100%;
    margin-bottom: 4.23vw;

  }
  .placeHolder{
    width: 0;
    height: 26vw;
  }
  .bottom {
    width: 100%;
    height: 29vw;
    position: fixed;
    bottom: 0;
    left: 0;
    overflow: hidden;
    box-sizing: border-box;
    background: rgba(116, 129, 181, 0.55);
    
  }
  .btn {
    display: block;
    width: 99.21vw;
    height: 29vw;
    margin: 0 auto;
   
  }
  .bottom_txt {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 15.8vw;
    line-height: 15.8vw;
    text-align: center;
    color: #fff;
    font-size: 6.4vw;
    transform: translate(-50%, -50%);
  }
  
</style>>
<template>
  <div class="page">
    <img class="logo" src="../assets/landpage1/logo.jpg" alt="" srcset="">
    <div class="feathers">
      <img src="../assets/landpage1/age.jpg" alt="">
      <img src="../assets/landpage1/palm.jpg" alt="">
      <img src="../assets/landpage1/hopo.jpg" alt="">
      <img src="../assets/landpage1/psychology.jpg" alt="">
      <div class="placeHolder"></div>
    </div>
    <div class="bottom" @click="goAppstore">
      <img class="btn" src="../assets/landpage1/button.gif" alt="">
      <p class="bottom_txt">FREE TO USE{{countdownTxt}}</p>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from "qs"
  import { maidian } from '../maidian.js'
  import {
    setOptions, bootstrap
  } from 'vue-gtag'
  export default {
    name: 'spreadTrack',
    metaInfo() {
      let cid = this.$route.query.cid;
      return maidian(cid)
    },
    data() {
      return {
        countdown: 5,
        countdownTxt: '(5)',
        timer: ''
      }
    },
    mounted() {
      this.enablePlugin()
      // eslint-disable-next-line no-undef
      if (window.gtagPageView) {
        // eslint-disable-next-line no-undef
        window.gtagPageView()
      }
      this.enablePlugin()
      this.timer = setInterval(() => {
        this.countdown = this.countdown - 1
        this.countdownTxt = `(${this.countdown})`
        // eslint-disable-next-line no-console
        console.log(this.countdown)
        if (this.countdown === 0) {
          this.countdownTxt = ''
          this.goAppstore()
          clearInterval(this.timer)
        }
      }, 1000)
      let cid = this.$route.query.cid;
      if (cid) {
        let params = {
          imei: 'h5',
          channel: cid,
          ch: 'h5',
          language: 'test'
        }
        // let baseApi = 'https://www.liferesting.com'
        let baseApi = process.env.NODE_ENV === 'production' ? 'https://www.liferesting.com' : '';
        axios.post(baseApi + '/api/H5Record/interface', qs.stringify(params)).then(response => {
          let data = response.data;
          // eslint-disable-next-line no-console
          console.log(data)
        })
      }
    },
    methods: {
      enablePlugin() {
        setOptions({
          config: {
            id: 'UA-173073542-1' 
          }
        })
        bootstrap().then(() => {
          // all done!
        })
      },
      goAppstore() {
        // eslint-disable-next-line no-undef
        if (window.gtag_report_conversion) {
          // eslint-disable-next-line no-undef
          window.gtag_report_conversion()
        }
        window.location.href = 'https://apps.apple.com/us/app/life-fun-funny-test-on-life/id1513875953'
      }
    }
  }
</script>